import React from "react";
import { Form } from "react-bootstrap";
import { TFrequencyOption } from "../../../../../api/endpoints/SubsetOption";
import CheckboxListSelector from "../../../CheckboxListSelector";
import Footnote from "../../../Footnote";
import FormError from "../../../FormError";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
  spec: TFrequencyOption;
}

const FrequencyField = (props: Props) => {
  const { formik, spec } = props;

  return (
    <Form.Group controlId="frequency">
      <Form.Label>Frequencies</Form.Label>
      <CheckboxListSelector
        options={spec.value.frequency}
        values={formik.values.frequency}
        name="frequency"
        onChange={values => formik.setFieldValue('frequency', values.sort())}
      />

      <FormError
        message={formik.errors.frequency as TFormErrorMessage}
        when={formik.touched.frequency && Boolean(formik.errors.frequency)}
      />

      <Footnote text={spec.footnote} />
    </Form.Group>
  )
}

export default FrequencyField;
